import React, { useState } from 'react';
import { Grid, Backdrop, Snackbar, CircularProgress, Typography, Box, TextField, Autocomplete, Container, Card, CardContent, Divider, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Alert from 'src/components/Alert';
import Page1 from 'src/components/Page';
import axios from 'src/utils/axios';
import TechGptChatbox from 'src/components/TechGpt/TechGptChatbox'
import SmartToyIcon from '@mui/icons-material/SmartToy';

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
};


const TeknisyenKocuChat = () => {
    const theme = useTheme();

    const [productsData, setProductsData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productInputValue, setProductInputValue] = useState("");
    const [documentBankNoList, setDocumentBankNoList] = useState([]);
    const [techGptPopUp, setTechGptPopUp] = useState(false);
    const [bankNoInput, setBankNoInput] = useState("");

    const [productLoading, setProductLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('default');
    const [responseMessage, setResponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const handleGetProductsBySearchTerm = (searchTerm) => {
        setProductLoading(true);
        axios.get(`/GetProductsBySearchTerm/${searchTerm}`)
            .then((response) => {
                const data = response.data;
                setProductsData(data);
                setProductLoading(false);
            }).catch((err) => {
                setProductLoading(false);
            });
    }

    const handleChangeSelectedProduct = (event, newValue) => {
        setSelectedProduct(newValue);

        if (newValue) {
            const userModelCode = newValue.KUL_MODEL_KODU;
            setLoading(true);
            axios.get(`/GetBankNoForTeknisyenKocu/${userModelCode}`)
                .then((response) => {
                    const data = response.data;
                    setDocumentBankNoList(data ? data : []);

                    let bankNoList = [];
                    data.map((x) => {
                        bankNoList.push(x.BANKANO);
                    })
                    setBankNoInput(bankNoList.toString());

                    setLoading(false);
                }).catch((err) => {
                    setLoading(false);
                });
        } else {
            setDocumentBankNoList([]);
        }

    }

    const handleChatBox = () => {
        if (!bankNoInput || !String(bankNoInput).trim()) {
            setResponseMessage({
                ErrorCode: '1000',
                ErrorDescription: 'Lütfen önce bir ürün seçiniz!...'
            });
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setTechGptPopUp(true);
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') return;
        setUyari(false);
    };

    return (
        <Page1 sx={styles.root}>
                <Backdrop sx={styles.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar
                    open={uyari}
                    autoHideDuration={10000}
                    onClose={uyariKapat}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert
                        onClose={uyariKapat}
                        variant={uyariTip}
                        message={responseMessage.ErrorDescription}
                    />
                </Snackbar>
                <Container maxWidth="lg">
                    <Card>
                        <CardContent>
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <SmartToyIcon style={{ fontSize: 48, color: '#FF9800' }} />
                                <Typography variant="h6" mt={1}>
                                    Teknisyen Koçu
                                </Typography>
                            </Box>
                        </CardContent>
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 2
                                    }} />
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 8
                                    }}>
                                    <Autocomplete
                                        options={productsData || []}
                                        getOptionLabel={(option) => option.TANIM || ''}
                                        value={selectedProduct || null}
                                        inputValue={productInputValue}
                                        onInputChange={(e, newValue, reason) => {
                                            setProductInputValue(newValue ?? "");
                                            if (reason === "input") {
                                                if ((newValue?.length ?? 0) > 2) {
                                                    handleGetProductsBySearchTerm(newValue);
                                                }
                                            }
                                            if (reason === "clear") {
                                                handleChangeSelectedProduct(e, null);
                                                setProductInputValue("");
                                                setBankNoInput("");
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) =>
                                            option.MODEL_KODU === value.MODEL_KODU
                                        }
                                        onChange={(event, newValue) => {
                                            handleChangeSelectedProduct(event, newValue);
                                            if (newValue) {
                                                setProductInputValue(newValue["ACIKLAMA"] ?? "");
                                            } else {
                                                setProductInputValue("");
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Ürün Ara"
                                                placeholder="Ürün Model Kodu ya da açıklaması ile arama yapabilirsiniz..."
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {productLoading ? <CircularProgress size={18} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                        sx={{
                                            '& .MuiAutocomplete-endAdornment': {
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 2
                                    }} />
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }} />
                                <Grid
                                    textAlign={'center'}
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        mt={1}
                                    >
                                        Destek almak istediğiniz ürünü listeden aratarak sohbeti başlatabilirsiniz.
                                    </Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }} />

                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }} />
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        sx={styles.button}
                                        onClick={() => { handleChatBox(); }}
                                    >
                                        SOHBETİ BAŞLAT
                                    </Button>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 4
                                    }} />
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            {techGptPopUp && (
                <TechGptChatbox
                    open={techGptPopUp}
                    onClose={() => setTechGptPopUp(false)}
                    userModelCode={selectedProduct?.KUL_MODEL_KODU}
                    urunAciklama={selectedProduct?.ACIKLAMA}
                />
            )}
        </Page1 >
    );

}

export default TeknisyenKocuChat;